import { StreamData } from 'types/streamData'
import { getDisplayTexts } from 'utils/geoInfoUtil'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const authorGeoHighResolver: FieldResolver = (metadata: Metadata) =>
  ({ authorGeoHigh: getDisplayTexts(metadata.getAuthorGeoInfos()) } as StreamData)

export default authorGeoHighResolver
